import { MapPin, Trash2, Building2 } from 'lucide-react';
import axios from 'axios';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Module C — menu latéral « Mes Adresses » (projets extérieurs). */
export const MyAddressesSidebar = ({ items, activeId, onSelect, onDeleted }) => (
  <aside className="absolute top-4 left-4 bottom-5 z-[500] w-[264px] rounded-xl flex flex-col overflow-hidden"
         style={{ background: 'rgba(10,10,13,0.86)', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.1)' }}
         data-testid="my-addresses-sidebar">
    <div className="px-3.5 py-3" style={{ borderBottom: '1px solid rgba(255,255,255,0.08)' }}>
      <span className="text-[10px] uppercase tracking-[0.2em] font-bold" style={{ color: 'var(--c-gold)' }}>
        Mes Adresses
      </span>
      <p className="text-[10.5px] mt-0.5 text-gray-500">{items.length} projet(s) extérieur(s)</p>
    </div>
    <div className="flex-1 overflow-y-auto p-2 space-y-1.5">
      {items.length === 0 && (
        <p className="text-[11px] text-gray-500 px-2 py-4 leading-relaxed">
          Recherchez une adresse pour créer votre premier projet extérieur.
        </p>
      )}
      {items.map((it) => (
        <div key={it.map_project_id}
             className="group rounded-lg px-2.5 py-2 cursor-pointer transition-colors"
             style={{
               background: activeId === it.map_project_id ? 'rgba(217,160,91,0.14)' : 'rgba(255,255,255,0.03)',
               border: `1px solid ${activeId === it.map_project_id ? 'rgba(217,160,91,0.4)' : 'rgba(255,255,255,0.06)'}`,
             }}
             onClick={() => onSelect(it)}
             data-testid={`address-item-${it.map_project_id}`}>
          <div className="flex items-center gap-2">
            <MapPin className="w-3.5 h-3.5 shrink-0" style={{ color: 'var(--c-gold)' }} />
            <span className="text-[12px] font-semibold text-gray-100 truncate flex-1">{it.name}</span>
            <button type="button" className="opacity-0 group-hover:opacity-100 transition-opacity"
              data-testid={`address-delete-${it.map_project_id}`}
              onClick={async (e) => {
                e.stopPropagation();
                await axios.delete(`${API}/map-projects/${it.map_project_id}`, { withCredentials: true });
                toast.success('Adresse supprimée');
                onDeleted?.();
              }}>
              <Trash2 className="w-3 h-3 text-gray-500 hover:text-rose-400" />
            </button>
          </div>
          <div className="mt-1 flex items-center gap-2 text-[9.5px] text-gray-500">
            {it.footprint?.length >= 3 && <span className="inline-flex items-center gap-1"><Building2 className="w-2.5 h-2.5" />emprise</span>}
            {it.frozen_camera && <span style={{ color: 'var(--c-gold)' }}>zone figée</span>}
            {(it.renders || []).filter((r) => r.status === 'completed').length > 0 && (
              <span className="text-emerald-400">{it.renders.filter((r) => r.status === 'completed').length} rendu(s)</span>
            )}
          </div>
        </div>
      ))}
    </div>
  </aside>
);
